(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

  
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kejsar-video-gallery"] && !Shopify.designMode) return;
  try {
    
const KS_SWIPER = window.KS_SWIPER || (window.KS_SWIPER = {
  loaded: false,
  promise: null,
  load() {
    if (this.promise) return this.promise;

    this.promise = new Promise((resolve, reject) => {
      const done = () => resolve();

      // CSS (once)
      if (!document.querySelector('#swiper-stylesheet')) {
        const stylesheet = document.createElement('link');
        stylesheet.href = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css';
        stylesheet.rel = 'stylesheet';
        stylesheet.id = 'swiper-stylesheet';
        stylesheet.onload = () => {};
        document.head.appendChild(stylesheet);
      }

      // Script (once)
      if (window.Swiper) return done();

      let script = document.querySelector('#swiper-script');
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js';
        script.id = 'swiper-script';
        script.defer = true;
        script.onload = () => done();
        script.onerror = reject;
        document.head.appendChild(script);
      } else {
        // If script exists but Swiper not ready yet, wait for load
        script.addEventListener('load', () => done(), { once: true });
      }
    });

    return this.promise;
  }
});

class KsShoppableVideos extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
    this._initObserver = null;
  }

  connectedCallback() {
    // Init only when near viewport
    this._initObserver = new IntersectionObserver(async (entries) => {
      if (!entries.some(e => e.isIntersecting)) return;

      this._initObserver.disconnect();

      await KS_SWIPER.load();
      this.initSwiper();
      this.bindVideoControls();
      this.syncActiveSlideVideo(); // start in a safe state
    }, { rootMargin: '0px 0px 400px 0px' });

    this._initObserver.observe(this);
  }

  disconnectedCallback() {
    try { this._initObserver?.disconnect(); } catch(e) {}
    try { this._swiper?.destroy(true, true); } catch(e) {}
    this._swiper = null;
  }

  initSwiper() {
    if (this._swiper) return;

    const el = this.querySelector('.swiper');
    if (!el || !window.Swiper) return;

    this._swiper = new window.Swiper(el, this.swiperOptions());

    this._swiper.on('slideChange', () => this.syncActiveSlideVideo());
    this._swiper.on('transitionEnd', () => this.syncActiveSlideVideo());
  }

  swiperOptions() {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    return {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: this.querySelector('.swiper-pagination'),
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: (currentClass, totalClass) =>
          `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },

      // Performance helpers
      preloadImages: false,

      // Mousewheel can be heavy/buggy on mobile
      mousewheel: isMobile ? false : {
        enabled: true,
        forceToAxis: true
      }
    };
  }

  bindVideoControls() {
    // Button click
    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper')?.querySelector('video');
        if (video) this.toggleVideo(video);
      });
    });

    // Video click
    this.querySelectorAll('video').forEach(video => {
      // Make iOS happier
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      video.addEventListener('click', () => this.toggleVideo(video));
    });
  }

  pauseAll(exceptVideo = null) {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(card => {
      const v = card.querySelector('video');
      if (v && v !== exceptVideo) {
        card.setAttribute('data-is-playing', 'false');
        try { v.pause(); } catch(e) {}
        v.muted = true;
      }
    });
  }

  syncActiveSlideVideo() {
    // Default: pause everything. Only autoplay on active slide if its block setting says autoplay.
    this.pauseAll();

    const activeSlide = this.querySelector('.swiper-slide-active');
    const card = activeSlide?.querySelector('.ks-shoppable-videos-card');
    const video = card?.querySelector('video');
    if (!card || !video) return;

    // Read the attribute you set in Liquid (data-autoplay)
    const shouldAutoplay = video.getAttribute('data-autoplay') === 'true';

    if (shouldAutoplay) {
      card.setAttribute('data-is-playing', 'true');
      video.muted = true; // keep autoplay muted for reliability
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }
  }

  toggleVideo(video) {
    const card = video.closest('.ks-shoppable-videos-card');
    if (!card) return;

    // Stop everything else
    this.pauseAll(video);

    const isPlaying = card.getAttribute('data-is-playing') === 'true';

    if (isPlaying) {
      card.setAttribute('data-is-playing', 'false');
      try { video.pause(); } catch(e) {}
      video.muted = true;
    } else {
      card.setAttribute('data-is-playing', 'true');
      // User interaction → you can unmute here
      video.muted = false;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }
  }
}

customElements.define('ks-shoppable-videos', KsShoppableVideos);



  } catch(e) { console.error(e); }
})();
})();
